type BlobType = {
	fileStream: BlobPart;
	contentType: string;
	url?: never;
};

type UrlType = {
	url: string;
	contentType?: never;
	fileStream?: never;
};

function downloadDocuments(params: BlobType | UrlType, fileName: string) {
	let href = '';

	if (params?.url) {
		href = params?.url;
	}

	if (params?.fileStream) {
		href = URL.createObjectURL(new Blob([params.fileStream], { type: params.contentType }));
	}

	const link = document.createElement('a');
	link.download = fileName;
	link.href = href;

	if (params?.url) {
		link.target = '_blank';
	}

	link.click();
	link.remove();
}

export default downloadDocuments;
